module.exports = "td,th {\r\n  text-align: center;\r\n  } "